import { render, staticRenderFns } from "./registrated.vue?vue&type=template&id=7007d9d1&"
import script from "./registrated.vue?vue&type=script&lang=js&"
export * from "./registrated.vue?vue&type=script&lang=js&"
import style0 from "./registrated.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports